import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const wellswoodConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Wellswood Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Wellswood, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_wellswood',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Wellswood',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Wellswood Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     quiet, well established neighborhood of <strong>Wellswood</strong>. Tucked 
     between North Tampa and the Hillsborough River, this community features 
     charming older homes shaded by large mature trees that have grown close 
     to structures, driveways, and utility lines over many decades. Our team 
     handles those trees with the care and skill the neighborhood deserves.`,

    `We specialize in <strong>hazardous tree removal and canopy management in 
     mature urban neighborhoods</strong> large overhanging limbs near older 
     homes, storm weakened trunks, trees with surface roots lifting pavement 
     and threatening foundations, and precision removals on tight residential 
     lots. We work safely and cleanly on every job.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care 
     throughout <strong>Wellswood</strong> and surrounding 
     <strong>Central Tampa</strong> neighborhoods keeping your home 
     safe and your landscape looking its best all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Wellswood, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Wellswood = () => <LocationPage config={wellswoodConfig} />;
export default Services_Wellswood;
